
































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DropDownButton extends Vue {
  selectedText = "";
  dropdownVisible = false;

  @Prop() DropDownOptions!: Array<string>;
  @Prop() SelectedOption!: string;
  @Prop() SelectAnOptionText!: string; 

  get SelectedText(): string {
    let returnVal =  this.SelectAnOptionText;
    if (this.SelectedOption != null && this.SelectedOption != "") {
      returnVal = this.SelectedOption;
    }
    return returnVal;
  }

  get DropDownItems(): Array<any> {
    const options = new Array<any>();
    if (this.DropDownOptions != null) {
      for (let i = 0; i < this.DropDownOptions.length; i++) {
        options.push({
          idx: i,
          name: this.DropDownOptions[i]
        });
      }
    }
    return options;
  }

  public handleOptionClick(v: string): void {
    this.selectedText = v;
    this.dropdownVisible = false;
    this.$emit("dropdown", v);
  }

  public handleButtonClick(): void {
    this.dropdownVisible = true;
  }
}
